import { Button as AntdButton } from 'antd'
import clsx from 'clsx'
import s from './button.module.scss'

export function Button({ className, children, ...args }) {
  return (
    <AntdButton {...args} className={clsx(s.loginBtn, className)}>
      {children}
    </AntdButton>
  )
}
